/* Mouvair Stories — fila de círculos + visor tipo Instagram Stories.
   Vanilla JS, sin dependencias externas. Dos Web Components:
   <mouvair-stories>       fila de círculos (lee su propio JSON embebido)
   <mouvair-story-viewer>  visor vertical fullscreen (uno por sección)
*/
(function () {
  'use strict';

  if (customElements.get('mouvair-stories')) return;

  var IMAGE_DURATION = 5000; // ms
  var VIDEO_FALLBACK_DURATION = 15000; // ms, por si el video no reporta duración

  function findViewer(sectionId) {
    return document.querySelector('mouvair-story-viewer[data-section-id="' + sectionId + '"]');
  }

  function findStoriesHost(sectionId) {
    return document.querySelector('mouvair-stories[data-section-id="' + sectionId + '"]');
  }

  class MouvairStoriesEl extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-mouvair-stories-json]');
      this.stories = [];
      if (dataEl) {
        try { this.stories = JSON.parse(dataEl.textContent || '[]'); } catch (err) { this.stories = []; }
      }
      this.circles = Array.prototype.slice.call(this.querySelectorAll('.mouvair-stories__circle'));
      var self = this;
      this.circles.forEach(function (el, index) {
        el.addEventListener('click', function () { self.openAt(index); });
      });
    }

    openAt(index) {
      var viewer = findViewer(this.dataset.sectionId);
      if (!viewer || !this.stories.length) return;
      viewer.openStory(this.stories, index, this.circles[index]);
    }

    markSeen(index) {
      var el = this.circles[index];
      if (el) el.classList.add('is-seen');
    }
  }

  class MouvairStoryViewerEl extends HTMLElement {
    connectedCallback() {
      this.progressRow = this.querySelector('[data-progress]');
      this.avatarEl = this.querySelector('[data-avatar]');
      this.nameEl = this.querySelector('[data-name]');
      // OJO: el contenido (video/imagen) se inyecta SOLO dentro de
      // [data-media-content], nunca en [data-media] directamente. [data-media]
      // también contiene los botones de avance (data-prev/data-next), el
      // título y el estado vacío como hermanos permanentes; si el contenido
      // se limpiara con innerHTML sobre [data-media] esos elementos se
      // borrarían del DOM en el primer render y dejarían de funcionar
      // (era la causa de que tocar la pantalla no avanzara de storie).
      this.mediaEl = this.querySelector('[data-media-content]');
      this.titleEl = this.querySelector('[data-title]');
      this.ctaEl = this.querySelector('[data-cta]');
      this.closeEl = this.querySelector('[data-close]');
      this.muteEl = this.querySelector('[data-mute]');
      this.muteIconOn = this.querySelector('.mouvair-story-viewer__mute-icon--on');
      this.muteIconOff = this.querySelector('.mouvair-story-viewer__mute-icon--off');
      this.prevZone = this.querySelector('[data-prev]');
      this.nextZone = this.querySelector('[data-next]');
      this.emptyEl = this.querySelector('[data-empty]');

      this.stories = [];
      this.storyIndex = 0;
      this.itemIndex = 0;
      this.activeTimer = null;
      this.currentFill = null;
      this.soundOn = true;
      this.lastFocused = null;

      var self = this;
      if (this.closeEl) this.closeEl.addEventListener('click', function () { self.close(); });
      if (this.prevZone) this.prevZone.addEventListener('click', function () { self.prev(); });
      if (this.nextZone) this.nextZone.addEventListener('click', function () { self.next(); });
      if (this.ctaEl) this.ctaEl.addEventListener('click', function () { self.handleCta(); });
      if (this.muteEl) this.muteEl.addEventListener('click', function () { self.toggleSound(); });
      document.addEventListener('keydown', function (e) { self.handleKey(e); });
      this.updateMuteButton();
    }

    openStory(stories, index, triggerEl) {
      this.stories = stories;
      this.storyIndex = index;
      this.itemIndex = 0;
      this.lastFocused = triggerEl || document.activeElement;
      this.hidden = false;
      this.renderItem();
      if (this.closeEl) this.closeEl.focus();
    }

    close() {
      clearTimeout(this.activeTimer);
      this.pauseVideo();
      this.hidden = true;
      var host = findStoriesHost(this.dataset.sectionId);
      if (host) host.markSeen(this.storyIndex);
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus();
    }

    handleKey(e) {
      if (this.hidden) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowRight') this.next();
      if (e.key === 'ArrowLeft') this.prev();
    }

    currentStory() { return this.stories[this.storyIndex]; }
    currentItem() {
      var story = this.currentStory();
      return story ? story.items[this.itemIndex] : null;
    }

    next() {
      var story = this.currentStory();
      if (!story) { this.close(); return; }
      if (this.itemIndex < story.items.length - 1) {
        this.itemIndex++;
        this.renderItem();
        return;
      }
      var host = findStoriesHost(this.dataset.sectionId);
      if (host) host.markSeen(this.storyIndex);
      if (this.storyIndex < this.stories.length - 1) {
        this.storyIndex++;
        this.itemIndex = 0;
        this.renderItem();
      } else {
        this.close();
      }
    }

    prev() {
      if (this.itemIndex > 0) {
        this.itemIndex--;
        this.renderItem();
      } else if (this.storyIndex > 0) {
        this.storyIndex--;
        var prevStory = this.currentStory();
        this.itemIndex = prevStory && prevStory.items.length ? prevStory.items.length - 1 : 0;
        this.renderItem();
      }
    }

    pauseVideo() {
      var video = this.mediaEl ? this.mediaEl.querySelector('video') : null;
      if (video) video.pause();
    }

    buildProgressBars(itemCount) {
      if (!this.progressRow) return;
      this.progressRow.innerHTML = '';
      this.currentFill = null;
      for (var i = 0; i < itemCount; i++) {
        var bar = document.createElement('span');
        bar.className = 'mouvair-story-viewer__bar';
        var fill = document.createElement('span');
        fill.className = 'mouvair-story-viewer__bar-fill';
        if (i < this.itemIndex) {
          fill.style.width = '100%';
        } else if (i === this.itemIndex) {
          fill.style.width = '0%';
          this.currentFill = fill;
        }
        bar.appendChild(fill);
        this.progressRow.appendChild(bar);
      }
    }

    runTimer(duration) {
      clearTimeout(this.activeTimer);
      var self = this;
      this.activeTimer = setTimeout(function () { self.next(); }, duration);
      var fill = this.currentFill;
      if (fill) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.classList.add('is-animating');
            fill.style.transitionDuration = duration + 'ms';
            fill.style.width = '100%';
          });
        });
      }
    }

    renderItem() {
      clearTimeout(this.activeTimer);
      this.pauseVideo();
      var story = this.currentStory();
      var item = this.currentItem();
      if (!story) { this.close(); return; }

      if (this.nameEl) this.nameEl.textContent = story.name || '';
      if (this.avatarEl) this.avatarEl.style.backgroundImage = story.coverUrl ? 'url(' + story.coverUrl + ')' : 'none';

      // Story sin contenidos cargados todavía (el bloque no tiene items
      // seleccionados en el picker "Contenidos"): en vez de cerrarse solo
      // (que se veía como "no abre"), mostramos un estado vacío explicativo
      // y dejamos que el usuario cierre manualmente con la X.
      if (!item) {
        if (this.mediaEl) this.mediaEl.innerHTML = '';
        if (this.titleEl) this.titleEl.textContent = '';
        if (this.ctaEl) this.ctaEl.hidden = true;
        if (this.progressRow) this.progressRow.innerHTML = '';
        if (this.emptyEl) this.emptyEl.hidden = false;
        return;
      }
      if (this.emptyEl) this.emptyEl.hidden = true;

      if (this.titleEl) this.titleEl.textContent = item.title || '';
      if (this.ctaEl) {
        this.ctaEl.textContent = item.cta || 'Ver producto';
        this.ctaEl.hidden = !item.dest;
      }

      this.buildProgressBars(story.items.length);

      if (this.mediaEl) this.mediaEl.innerHTML = '';
      var self = this;

      if (item.type === 'video' && item.videoSources && item.videoSources.length) {
        var best = item.videoSources[item.videoSources.length - 1];
        var video = document.createElement('video');
        video.src = best.url;
        // Intentamos reproducir con sonido (el usuario ya interactuó con la
        // pantalla al tocar el círculo para abrir la storie, lo que habilita
        // el audio en la mayoría de los navegadores). Si el navegador igual
        // bloquea el autoplay con sonido, reintentamos silenciado para que
        // el video no se trabe, y dejamos el botón de altavoz para que la
        // persona active el sonido manualmente.
        video.muted = !this.soundOn;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        if (item.posterUrl) video.poster = item.posterUrl;
        var started = false;
        video.addEventListener('loadedmetadata', function () {
          if (started) return;
          started = true;
          var ms = video.duration && isFinite(video.duration) ? video.duration * 1000 : VIDEO_FALLBACK_DURATION;
          self.runTimer(ms);
        });
        video.addEventListener('ended', function () { self.next(); });
        if (this.mediaEl) this.mediaEl.appendChild(video);
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {
            if (!video.muted) {
              video.muted = true;
              self.soundOn = false;
              self.updateMuteButton();
              video.play().catch(function () {});
            }
          });
        }
        // Respaldo por si 'loadedmetadata' nunca llega
        setTimeout(function () { if (!started) { started = true; self.runTimer(VIDEO_FALLBACK_DURATION); } }, 800);
      } else {
        var img = document.createElement('img');
        img.src = item.imageUrl || item.posterUrl || '';
        img.alt = item.title || '';
        if (this.mediaEl) this.mediaEl.appendChild(img);
        this.runTimer(IMAGE_DURATION);
      }
    }

    toggleSound() {
      this.soundOn = !this.soundOn;
      var video = this.mediaEl ? this.mediaEl.querySelector('video') : null;
      if (video) {
        video.muted = !this.soundOn;
        if (this.soundOn) video.play().catch(function () {});
      }
      this.updateMuteButton();
    }

    updateMuteButton() {
      if (this.muteIconOn) this.muteIconOn.hidden = !this.soundOn;
      if (this.muteIconOff) this.muteIconOff.hidden = this.soundOn;
      if (this.muteEl) this.muteEl.setAttribute('aria-pressed', this.soundOn ? 'false' : 'true');
    }

    resolveUrl(dest) {
      if (!dest) return '';
      if (/^https?:\/\//i.test(dest)) return dest;
      return window.location.origin + (dest.charAt(0) === '/' ? dest : '/' + dest);
    }

    handleCta() {
      var item = this.currentItem();
      if (!item || !item.dest) return;
      window.location.href = this.resolveUrl(item.dest);
    }
  }

  customElements.define('mouvair-stories', MouvairStoriesEl);
  customElements.define('mouvair-story-viewer', MouvairStoryViewerEl);
})();
